import gelaatsverzorgingen from "../assets/images/categories/gelaatsverzorgingen.webp";
import voetverzorgingen from "../assets/images/categories/voetverzorgingen.webp";

import bloedsinaasappel from "../assets/images/gelaat/bloedsinaasappel.webp";
import purifiant from "../assets/images/gelaat/purifiant.webp";
import bamboe from "../assets/images/gelaat/bamboe.webp";
import spiruline from "../assets/images/gelaat/spiruline.webp";
import spirulineOog from "../assets/images/gelaat/spiruline_oog.webp";
import yuzu from "../assets/images/gelaat/yuzu.jpg";
import diamant from "../assets/images/gelaat/diamant.webp";
import basisGelaat from "../assets/images/gelaat/basis_gelaat.jpg";
import muesli from "../assets/images/gelaat/muesli.jpg";
import jardin from "../assets/images/gelaat/jardin.webp";
import soinSolideGelaat from "../assets/images/gelaat/soin-solide-gelaat.webp";
import bakuchiol from "../assets/images/gelaat/bakuchiol.jpg";

import figuurCat from "../assets/images/categories/figuur_cat.jpg";
import figuur1 from "../assets/images/figuur/figuur_1.jpg";
import figuur2 from "../assets/images/figuur/figuur_2.jpg";
import figuur3 from "../assets/images/figuur/figuur_3.jpg";

import soinsdumonde from "../assets/images/lichaam/soinsdumonde.jpg";
import peelingRug from "../assets/images/lichaam/peeling_rug.webp";
import relaxmassageRug from "../assets/images/lichaam/relaxmassage_rug.webp";
import peelingLichaam from "../assets/images/lichaam/peeling_lichaam.webp";
import relaxAroma from "../assets/images/lichaam/relax_aroma.webp";
import relaxKaarsen from "../assets/images/lichaam/relax_kaarsen.webp";
import relaxLichaam from "../assets/images/lichaam/relaxmassage_lichaam.webp";
import soinSolideLichaam from "../assets/images/lichaam/soin-solide-lichaam.webp";

import handverzorgingen from "../assets/images/categories/handverzorgingen.webp";
import gelnagels from "../assets/images/handen/gelnagels.jpg";
import gelish from "../assets/images/handen/gelish.webp";
import basisManicure from "../assets/images/handen/basis_manicure.webp";
import spaManicure from "../assets/images/handen/spa_manicure.webp";
import paraffine from "../assets/images/handen/paraffine.webp";
import handMassage from "../assets/images/handen/hand_massage.webp";

import lichaamCat from "../assets/images/categories/lichaam_cat.webp";
import spaPedicure from "../assets/images/voeten/spa_pedicure.webp";
import basisPedicure from "../assets/images/voeten/pedicure.webp";
import gelishVoeten from "../assets/images/voeten/gelish_voeten.webp";
import paraffineVoet from "../assets/images/voeten/paraffine_voet.webp";
import massageVoet from "../assets/images/voeten/massage_voet.webp";

import ontharingenCat from "../assets/images/categories/ontharingen_cat.webp";
import benenVolledig from "../assets/images/ontharingen/benen_volledig.webp";
import onderbenen from "../assets/images/ontharingen/onderbenen.webp";
import armen from "../assets/images/ontharingen/armen.webp";
import wenkbrauwen from "../assets/images/ontharingen/wenkbrauwen.webp";
import rug from "../assets/images/ontharingen/rug.webp";
import oksels from "../assets/images/ontharingen/oksels.webp";
import bovenlip from "../assets/images/ontharingen/bovenlip.webp";
import rugBorst from "../assets/images/ontharingen/rug_borst.webp";
import bovenlipKinWangen from "../assets/images/ontharingen/bovenlip_kin_wangen.webp";
import neus from "../assets/images/ontharingen/neus.webp";
import kin from "../assets/images/ontharingen/kin.webp";

import wimpers from "../assets/images/wimpers/wimpers.webp";
import wimpers2 from "../assets/images/wimpers/wimpers2.webp";
import wimpers3 from "../assets/images/wimpers/wimpers3.webp";
import wimpers4 from "../assets/images/wimpers/wimpers4.webp";
import wimpersCat from "../assets/images/categories/wimpers_cat.webp";
import lashlift from "../assets/images/wimpers/lashlift.webp";
import wenkVerven from "../assets/images/wimpers/wenk_verven.webp";
import wimpVerven from "../assets/images/wimpers/wimp_verven.webp";
import epilerenWenk from "../assets/images/wimpers/epileren_wenk.webp";
import wenkWimpVerven from "../assets/images/wimpers/wenkwimp_verven.webp";

import dagMakeup from "../assets/images/makeup/dag_makeup.webp";
import feestMakeup from "../assets/images/makeup/feest_makeup.webp";
import makeupCat from "../assets/images/categories/makeup_cat.webp";

import hifuCat from "../assets/images/categories/hifu.jpeg";
import alles from "../assets/images/hifu/alles.jpg";
import decollete from "../assets/images/hifu/decollete.jpg";
import eye from "../assets/images/hifu/eye.jpeg";
import fullFace from "../assets/images/hifu/full-face.jpg";
import hals from "../assets/images/hifu/hals.jpg";
import lowerFace from "../assets/images/hifu/lower-face.jpg";
import onderkin from "../assets/images/hifu/onderkin.jpg";
import toning from "../assets/images/hifu/toning.jpg";
import upperFace from "../assets/images/hifu/upper-face.png";

import LaserCategory from "../assets/images/laser/man/LaserCategory.webp";
import laserBaardlijn from "../assets/images/laser/man/Man baardlijn.webp";
import laserManBorst from "../assets/images/laser/man/Man borst.webp";
import laserManBovenbenen from "../assets/images/laser/man/Man bovenbenen.webp";
import laserManBuik from "../assets/images/laser/man/Man buik.webp";
import laserManHals from "../assets/images/laser/man/Man hals.webp";
import laserManNek from "../assets/images/laser/man/Man nek.webp";
import laserManOksel from "../assets/images/laser/man/Man oksel.webp";
import laserManOnderbenen from "../assets/images/laser/man/Man onderbenen.webp";
import laserManOnderrug from "../assets/images/laser/man/Man onderrug.webp";
import laserManSchouders from "../assets/images/laser/man/Man schouders.webp";
import laserManVolledigeBenen from "../assets/images/laser/man/Man volledige benen.webp";
import laserManVolledigeRug from "../assets/images/laser/man/Man volledige rug.webp";
import laserManWenkbrauwen from "../assets/images/laser/man/Man wenkbrauwen.webp";

export const behandelingenMan = [
    {
        category: "HIFU Liftera",
        src: hifuCat,
        values: [
            {
                name: "Full face incl. hals",
                src: fullFace,
                description: "Een complete behandeling voor het hele gezicht en de hals, gericht op huidversteviging, contourverbetering en het verminderen van fijne lijntjes en rimpels.",
                price: 450
            },
            {
                name: "Upperface (wangen, ogen & voorhoofd)",
                src: upperFace,
                description: "Gericht op het verstevigen en liften van de bovenste gezichtszone. Vermindert fijne lijntjes, lift de wenkbrauwen en verstrakt de huid rondom de ogen en wangen voor een frissere uitstraling.",
                price: 300
            },
            {
                name: "Lowerface (wangen, kaaklijn & onderkin)",
                src: lowerFace,
                description: "Helpt bij het contouren en verstevigen van de onderkant van het gezicht. Vermindert verslapping rond de kaaklijn en onderkin, waardoor de gezichtscontouren scherper worden.",
                price: 300
            },
            {
                name: "Eye treatment",
                src: eye,
                description: "Specifiek ontworpen voor de gevoelige huid rondom de ogen. Vermindert wallen, kraaienpootjes en verslapping, waardoor de blik frisser en jeugdiger oogt.",
                price: 200
            },
            {
                name: "Onderkin & kaaklijn",
                src: onderkin,
                description: "Richt zich op het verminderen van een onderkin en het verstevigen van de kaaklijn. Helpt bij het strakker maken van de huid voor een meer gedefinieerde uitstraling.",
                price: 200
            },
            {
                name: "Decolleté",
                src: decollete,
                description: "Verbetert de stevigheid en textuur van de huid op het decolleté. Vermindert fijne lijntjes en geeft een egalere, jeugdige uitstraling aan deze vaak vergeten zone.",
                price: 150
            },
            {
                name: "Hals",
                src: hals,
                description: "Gericht op het liften en verstevigen van de hals. Helpt bij het verminderen van rimpels en verslapping voor een gladdere en strakkere huid.",
                price: 150
            },
            {
                name: "Full face, hals & decolleté",
                src: alles,
                description: "Een uitgebreide behandeling die het volledige gezicht, de hals en het decolleté aanpakt. Zorgt voor een gelifte & verstevigde huid met een natuurlijke glow.",
                price: 600
            },
            {
                name: "Toning",
                src: toning,
                description: "Deze behandeling richt zich op de bovenste huidlaag en is ideaal voor het verfijnen van de huidtextuur. Het helpt bij acne, grove poriën en rimpels op het voorhoofd, terwijl het tegelijkertijd de huidstructuur en teint verbetert. Houd er rekening mee dat het effect tijdelijk is en na ongeveer drie weken opnieuw kan worden uitgevoerd. Perfect voor een speciale gelegenheid of een avondje uit!",
                price: 100
            }
        ]
    },
    {
        category: "Laser ontharing",
        src: LaserCategory,
        values: [
            {
                name: "Baardlijn",
                src: laserBaardlijn,
                description: "",
                price: 175
            },
            {
                name: "Borst",
                src: laserManBorst,
                description: "",
                price: 180
            },
            {
                name: "Bovenbenen",
                src: laserManBovenbenen,
                description: "",
                price: 210
            },
            {
                name: "Buik",
                src: laserManBuik,
                description: "",
                price: 140
            },
            {
                name: "Hals",
                src: laserManHals,
                description: "",
                price: 90
            },
            {
                name: "Nek",
                src: laserManNek,
                description: "",
                price: 70
            },
            {
                name: "Oksels",
                src: laserManOksel,
                description: "",
                price: 100
            },
            {
                name: "Onderbenen",
                src: laserManOnderbenen,
                description: "",
                price: 195
            },
            {
                name: "Onderrug",
                src: laserManOnderrug,
                description: "",
                price: 150
            },
            {
                name: "Schouders",
                src: laserManSchouders,
                description: "",
                price: 130
            },
            {
                name: "Volledige benen",
                src: laserManVolledigeBenen,
                description: "",
                price: 375
            },
            {
                name: "Volledige rug (incl schouders)",
                src: laserManVolledigeRug,
                description: "",
                price: 280
            },
            {
                name: "Wenkbrauwen (midden)",
                src: laserManWenkbrauwen,
                description: "",
                price: 60
            },
        ]
    },
    {
        category: "Gelaatsverzorgingen",
        src: gelaatsverzorgingen,
        values: [
            {
                name: "Basis gelaatsverzorging",
                src: basisGelaat,
                description: "Reiniging, dieptereiniging, indien gewenst epilatie wenkbrauwen en ontharen van de bovenlip, vapozone, zwarte puntjes, massage, masker en dagcrème.",
                price: 58
            },

            {
                name: "Verstevigende verzorging met Bakuchiol",
                src: bakuchiol,
                description: "Deze behandeling is op basis van bakuchiol, een plantaardig en huidvriendelijk alternatief voor retinol. Het helpt zichtbaar bij het verminderen van rimpels en het verbeteren van de elasticiteit. In combinatie met niacinamide en andere zorgvuldig geselecteerde actieve ingrediënten wordt de huid verstevigd en wordt de huidbarrière versterkt. De ideale behandeling voor vrouwen in de menopauze.",
                price: 82
            },

            {
                name: "Anti-aging behandeling met spiruline",
                src: spiruline,
                description: "Deze behandeling gaat de huid verstevigen. Hij doet de rimpels zichtbaar verminderen en gaat de span en veerkracht van de huid verbeteren.",
                price: 77
            },
            {
                name: "Luxe anti-age verzorging",
                src: diamant,
                description: "Deze behandeling bestrijdt doeltreffend rimpels, kraaienpootjes, verlies van stevigheid en pigmentvlekken. Deze lijn werd verrijkt met diamantpoeder en extract van witte parels om de kwaliteit en de glans van uw teint te verbeteren. Deze behandeling wordt uitgevoerd met behulp van massageparels, een revolutionaire massagetool die zorgt voor een volledig nieuwe ervaring en maximale ontspanning.",
                price: 101
            },
            {
                name: "Hydraterende behandeling met bamboe",
                src: bamboe,
                description: "Behandeling voor de huid die nood heeft aan hydratatie, soepelheid en stevigheid. Hoofdbestanddeel van deze behandeling zijn bamboe en aloe vera.",
                price: 67
            },
            {
                name: "Kalmerende behandeling met muesli",
                src: muesli,
                description: "Behandeling die de gevoelige huid gaat kalmeren en de droge huid gaat hydrateren. Het verminderd zichtbaar de roodheden, droogheid en ruwe uitzicht van de huid. Muesli gaat de huid versterken en helpt het evenwicht van het huidmicrobioom te behouden.",
                price: 63
            },
            {
                name: "Behandeling voor de oogcontouren met spiruline",
                src: spirulineOog,
                description: "Een doeltreffende verzorging om tekenen van vermoeidheid en veroudering tegen te gaan. Deze verzorging gaat rimpels zichtbaar verzachten en wallen verminderen. Boek je deze bovenop een gelaatsverzorging? Dan kan dit voor slechts 18€.",
                price: 29
            },
            {
                name: "Soin purifiant",
                src: purifiant,
                description: "Een zuiverende behandeling voor oneffenheden en de overmatige productie van talg. Hormonale schommelingen, warmte en vocht, vervuiling, onregelmatige levensstijl of zelfs stress kunnen overproductie van talg of huidonzuiverheden veroorzaken.",
                price: 63
            },
            {
                name: "Yuzu behandeling",
                src: yuzu,
                description: "Deze behandeling zorgt voor een lichtere, meer stralende teint en gaat pigmentvlekken vervagen. Bovendien zal de pigmentvorming ook worden afgeremd.",
                price: 69
            },

            {
                name: "EE* detox behandeling met bloedsinaasappel",
                src: bloedsinaasappel,
                description: "Deze behandeling zorgt dat de huid er minder vermoeid en terug fris uitziet, geeft een egale en heldere teint. Vitamine C is een van de hoofdbestanddelen van deze behandeling.",
                price: 63
            },

            {
                name: "Jardin aromatique",
                src: jardin,
                description: "Een reinigende en zuiverende behandeling voor een gladdere, zuiverdere huid met een frisse teint. Deze behandeling is zeer effectief, met name dankzij een dubbele grondige reiniging en een absorberend masker. Het is een ideale behandeling voor de huid die gevoelig is voor onzuiverheden, overtollig talg of verwijde poriën. Het is een essentiële behandeling om het uiterlijk van de huid te verbeteren en een gelijkmatige teint te herstellen.",
                price: 61
            }
        ]
    },
    {
        category: "Figuurcorrectie",
        src: figuurCat,
        values: [
            {
                name: "Ananas afslankbehandeling",
                src: figuur1,
                description: "Deze behandeling kan toegepast worden op volgende lichaamsdelen; dijen, heupen, billen, armen en buik. De behandeling gaat het uiterlijk van de huid ter hoogte van de behandelde zones verbeteren, verstevigen en het silhouet verfijnen.",
                price: 83
            },
            {
                name: "Ananas afslankbehandeling kuur (4 behandelingen)",
                src: figuur2,
                description: "Deze behandeling kan toegepast worden op volgende lichaamsdelen; dijen, heupen, billen, armen en buik. De behandeling gaat het uiterlijk van de huid ter hoogte van de behandelde zones verbeteren, verstevigen en het silhouet verfijnen.",
                price: 310
            },
            {
                name: "Ananas afslankbehandeling kuur (8 behandelingen)",
                src: figuur3,
                description: "Deze behandeling kan toegepast worden op volgende lichaamsdelen; dijen, heupen, billen, armen en buik. De behandeling gaat het uiterlijk van de huid ter hoogte van de behandelde zones verbeteren, verstevigen en het silhouet verfijnen.",
                price: 600
            },
        ]
    },
    {
        category: "Handverzorgingen",
        src: handverzorgingen,
        values: [
            {
                name: "Basis manicure",
                src: basisManicure,
                description: "Vijlen van de nagels, losmaken van de velletjes, achteruit duwen van de nagelriem,  verwijderen van de dode huid aan de nagelriem en afwerking met een voedende nagel olie. De nagels kunnen ook gelakt worden bij een manicure.",
                price: 26
            },
            {
                name: "Gelnagels",
                src: gelnagels,
                description: "Het gaat hier om kunstnagels met een speciale gel die je uithardt onder een UV-lamp of LED-lamp. Je kunt de gel laten aanbrengen op je natuurlijke nagels om ze te verstevigen of te verlengen. Voor een mooi resultaat wordt bij gelnagels eerst een basislaagje aangebracht, daarna volgt een gellaag, meestal twee kleurlaagjes en een eindlaag. De gelnagels blijven 3 tot 4 weken mooi zitten. Daarna kun je de gel laten bijwerken of verwijderen.",
                price: 50
            },
            {
                name: "Gelish & manicure",
                src: gelish,
                description: "Gelish is flexibel, duurzaam en eenvoudig te verwijderen. Met gelish hoeft je niet langer te wachten tot de nagels droog zijn na de behandeling. Afbrokkelen, krasjes en dofheid, zwakke en beschadigde nagels die snel inscheuren, … behoren definitief tot het verleden. Gelish nagels bieden u kwaliteit en comfort! Dit voor 3 tot 4 weken!",
                price: 39
            },
            {
                name: "Spa manicure",
                src: spaManicure,
                description: "Bij deze behandeling krijgt je eerst een handbadje waarbij de handen gepeeld worden. Dit om de dode huidcellen los te maken en te verwijderen. Nadien volgt de gewone manicure en een handmasker. Deze behandeling wordt afgewerkt met een zalige handmassage.",
                price: 41
            },
            {
                name: "Handmassage",
                src: handMassage,
                description: "Een handmassage zorgt niet alleen voor ontspanning maar ook voor een betere doorbloeding van de huid. Het maakt de handspieren soepeler en gaat de handen volledig ontspannen.",
                price: 9
            }
        ]
    },
    {
        category: "Voetverzorgingen",
        src: voetverzorgingen,
        values: [
            {
                name: "Basis pedicure",
                src: basisPedicure,
                description: "Knippen & vijlen van de nagels, losmaken van de velletjes ter hoogte van de nagelriem. Het verwijderen van eelt, likdoorns, ingegroeide nagels,… worden standaard toegepast bij onze pedicures. U wandelt het instituut buiten alsof u op wolkjes loopt.",
                price: 30
            },

            {
                name: "Gelish & pedicure",
                src: gelishVoeten,
                description: "Gelish is flexibel, duurzaam en eenvoudig te verwijderen. Met gelish hoeft je niet langer te wachten tot de nagels droog zijn na de behandeling. Afbrokkelen, krasjes en dofheid, zwakke en beschadigde nagels die snel inscheuren, … behoren definitief tot het verleden. Gelish nagels bieden u kwaliteit en comfort! Dit voor 6 tot 8 weken!",
                price: 41
            },
            {
                name: "Spa pedicure",
                src: spaPedicure,
                description: "Bij deze behandeling krijg je eerst een voetbadje waarbij de voeten gepeeld worden. Dit om de dode huidcellen los te maken en te verwijderen. Nadien volgt een pedicure en een voetmasker. Deze behandeling wordt afgewerkt met een zalige voetmassage.",
                price: 50
            },
            {
                name: "Voetmassage",
                src: massageVoet,
                description: "Een voetmassage geeft ontspanning voor je voeten, maar ook je hele lichaam. De voetmassage heeft als doel het bewerken van de voet spieren en het stimuleren van de bloedsomloop in de voet. De lymfen worden getraind om vocht af te voeren. Tijdens een voetmassage zullen diverse voetspieren droog gemaakt worden, om vervolgens met toenemende druk de spieren te stimuleren in hun vermogen. Een voetmassage kan verzachting bieden bij klachten en verschijnselen als spanning, hoofdpijn, slapeloosheid en koud, verkrampte en gespannen voeten.",
                price: 9
            },

        ]
    },
    {
        category: "Lichaamsverzorgingen",
        src: lichaamCat,
        values: [
            {
                name: "Relaxmassage volledig lichaam",
                src: relaxLichaam,
                description: "Een massage is niet alleen heerlijk ontspannend, het activeert ook de bloedsomloop. Hierdoor krijgen de spieren, organen, botten en huid meer verse voedingsstoffen. De energiedoorstroming wordt bevorderd, waardoor het lichaam nieuwe energie krijgt! Bovendien wordt de bloeddruk genormaliseerd door massage.",
                price: 64
            },
            {
                name: "Relaxmassage rug",
                src: relaxmassageRug,
                description: "Een massage is niet alleen heerlijk ontspannend, het activeert ook de bloedsomloop. Hierdoor krijgen de spieren, organen, botten en huid meer verse voedingsstoffen. De energiedoorstroming wordt bevorderd, waardoor het lichaam nieuwe energie krijgt! Bovendien wordt de bloeddruk genormaliseerd door massage.",
                price: 36
            },
            {
                name: "Peeling lichaam",
                src: peelingLichaam,
                description: "Behandeling om de dode huidcellen te verwijderen en nadien het lichaam te hydrateren. Ideaal voor het zonnebaden.",
                price: 74
            },
            {
                name: "Peeling rug",
                src: peelingRug,
                description: "Behandeling om de dode huidcellen te verwijderen en de rug nadien te hydrateren. Eventuele zwarte punten worden ook verwijderd.",
                price: 42
            },
            {
                name: "Relaxmassage met kaarsen",
                src: relaxKaarsen,
                description: "Een lichaamsmassage die u dankzij geurende warme olie meeneemt in een wereld van ontspanning.",
                price: 70
            }
        ]
    },
    {
        category: "Ontharingen",
        src: ontharingenCat,
        values: [
            {
                name: "Bovenlip of kin",
                src: bovenlip,
                description: "",
                price: 12
            },
            {
                name: "Bovenlip en kin",
                src: kin,
                description: "",
                price: 13
            },
            {
                name: "Bovenlip, kin & wangen",
                src: bovenlipKinWangen,
                description: "",
                price: 14
            },
            {
                name: "Benen tot aan de knie",
                src: onderbenen,
                description: "",
                price: 25
            },
            {
                name: "Benen volledig",
                src: benenVolledig,
                description: "",
                price: 35
            },
            {
                name: "Oksels",
                src: oksels,
                description: "",
                price: 13
            },
            {
                name: "Rug of borst",
                src: rug,
                description: "",
                price: 32
            },
            {
                name: "Rug & borst",
                src: rugBorst,
                description: "",
                price: 52
            },
            {
                name: "Neus & oren",
                src: neus,
                description: "",
                price: 14
            },
            {
                name: "Armen",
                src: armen,
                description: "",
                price: 24
            },
            {
                name: "Wenkbrauwen",
                src: wenkbrauwen,
                description: "",
                price: 12
            },
        ]
    },
    {
        category: "Wimper- en wenkbrauwverzorgingen",
        src: wimpersCat,
        values: [
            {
                name: "Wimperextensions (nieuwe set)",
                src: wimpers,
                description: "Wimperextensions werken eigenlijk net als gewone haar extensions. Er worden kleine haartjes op je eigen wimpers geplakt met een speciale (formaldehyde vrije) lijm. Dit zijn meestal synthetische haartjes, die kunnen variëren in kleur, dikte en lengte.",
                price: 125
            },
            {
                name: "Wimperextensions (mini bijwerking)",
                src: wimpers2,
                description: "Wil je je wimpers zo houden en het effect niet beperken  dan moet je ze regelmatig laten bijwerken. Hoe vaak hangt af van de cyclus van je eigen wimpers maar gemiddeld gebeurt dit om de 2 à 3 weken. Want je wimpers en extensions vallen op natuurlijke wijze uit. Na ongeveer 8 weken zijn ze allemaal uitgevallen en zijn er nieuwe in de plaats gegroeid.",
                price: 33
            },
            {
                name: "Wimperextensions (bijwerking na 3 weken)",
                src: wimpers3,
                description: "Wil je je wimpers zo houden en het effect niet beperken  dan moet je ze regelmatig laten bijwerken. Hoe vaak hangt af van de cyclus van je eigen wimpers maar gemiddeld gebeurt dit om de 2 à 3 weken. Want je wimpers en extensions vallen op natuurlijke wijze uit. Na ongeveer 8 weken zijn ze allemaal uitgevallen en zijn er nieuwe in de plaats gegroeid.",
                price: 41
            },
            {
                name: "Wimperextensions (bijwerking na 4 weken)",
                src: wimpers4,
                description: "Wil je je wimpers zo houden en het effect niet beperken  dan moet je ze regelmatig laten bijwerken. Hoe vaak hangt af van de cyclus van je eigen wimpers maar gemiddeld gebeurt dit om de 2 à 3 weken. Want je wimpers en extensions vallen op natuurlijke wijze uit. Na ongeveer 8 weken zijn ze allemaal uitgevallen en zijn er nieuwe in de plaats gegroeid.",
                price: 59
            },
            {
                name: "Lashlift met kleuren",
                src: lashlift,
                description: "Wimper Permanent! Voor sprekende ogen… Mooie, lange en gekrulde wimpers zorgen voor een open blik die de ogen optisch aanzienlijk groter laten lijken, zelfs bij korte wimpers. Dit resultaat blijft 6 tot 8 weken.",
                price: 57
            },
            {
                name: "Kleuren wimpers",
                src: wimpVerven,
                description: "De wimperverf voorziet de volledige wimperhaar van een gekleurd laagje, waardoor de gehele lengte van de wimper goed zichtbaar is. Hierdoor krijg je direct langer en voller uitziende wimpers.",
                price: 17
            },
            {
                name: "Kleuren wenkbrauwen",
                src: wenkVerven,
                description: "De verf legt een laagje om de wenkbrauwen, waardoor de wenkbrauwen meteen voller lijken. Vooral de uiteinden van de wenkbrauwen zijn vaak dunner, waardoor je ze bijna niet ziet. Met wenkbrauwverf zorg je ervoor dat je wenkbrauwen goed naar voren komen.",
                price: 17
            },
            {
                name: "Kleuren wimpers en wenkbrauwen",
                src: wenkWimpVerven,
                description: "",
                price: 29
            },
            {
                name: "Epileren wenkbrauwen",
                src: epilerenWenk,
                description: "",
                price: 12
            },
        ]
    },
    {
        category: "Make-up",
        src: makeupCat,
        values: [
            {
                name: "Dag make-up",
                src: dagMakeup,
                description: "Een dag make-up is bij voorkeur zo natuurlijk mogelijk en maakt de huid egaler en aantrekkelijker, met lichte accenten van kleur passend bij uw kleding of persoonlijkheid. Met lichte kleuren en toetsen die goed bij uw huidtype, kleding en persoonlijkheid passen, creëren we een frisse, natuurlijk ogende look.",
                price: 17
            },
            {
                name: "Feest make-up",
                src: feestMakeup,
                description: "Een schitterende feest make-up met feestelijke glitter-oogschaduw en sensuele glossy lippen. Stylish en trendy. Voor de feestdagen of iedere andere leuke en uitbundige feestelijke gelegenheid. Met donkere of gekleurde smokey eyes als uitgangspunt is deze feestlook heel gemakkelijk te maken. Alles draait om de ogen die met of zonder glitter zijn opgemaakt. Met deze make-up straal je de hele avond.",
                price: 45
            },
        ]
    }
];
